/**
 * sync-variant-from-image.js
 * Tema: Broadcast V6.0.2 (Invisible Themes) — Laneni Dom
 *
 * PROBLEMA QUE RESOLVE:
 * O Broadcast já sincroniza variante -> imagem (escolher uma opção troca a foto),
 * mas NAO sincroniza imagem -> variante (navegar na galeria/miniaturas nao muda
 * a opcao selecionada). Isto faz com que o "Adicionar ao carrinho" possa enviar
 * a primeira variante em vez da imagem visivel quando o cliente navega so pela galeria.
 *
 * O QUE FAZ:
 * Observa o atributo data-active-media do componente <product-images>. Sempre que
 * esse atributo muda (clique numa miniatura, seta, ou swipe/arrasto), procura entre
 * os dados do produto (script[data-product-json]) a variante cujo featured_media.id
 * corresponde a imagem agora visivel, e marca essa variante como selecionada,
 * disparando o evento "change" para que o tema (Ac/product-form) atualize preco,
 * disponibilidade e o input hidden name="id" usado no submit do carrinho.
 *
 * Onde a imagem nao corresponde a nenhuma variante especifica (imagem so do produto,
 * comum a varios modelos), nao faz nada -- preserva o comportamento atual.
 */
(function () {
  "use strict";

  function getSectionRoot(productImagesEl) {
    return productImagesEl.closest("[data-section-type]");
  }

  function getProductJSON(root) {
    var script = root.querySelector("[data-product-json]");
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function extractMediaId(activeMediaAttr) {
    if (!activeMediaAttr) return null;
    var parts = activeMediaAttr.split("-");
    var last = parts[parts.length - 1];
    var n = parseInt(last, 10);
    return isNaN(n) ? null : n;
  }

  function findVariantByMediaId(product, mediaId) {
    if (!product || !product.variants) return null;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (v.featured_media && v.featured_media.id === mediaId) {
        return v;
      }
    }
    return null;
  }

  function selectVariantInForm(root, variant) {
    if (!variant || !variant.options) return;

    var changedAny = false;

    variant.options.forEach(function (optionValue, index) {
      var optionPosition = index + 1;
      var wrapper = root.querySelector(
        '[data-option-position="' + optionPosition + '"]'
      );
      if (!wrapper) return;

      var radios = wrapper.querySelectorAll(
        'input[data-single-option-selector][data-index="option' +
          optionPosition +
          '"]'
      );
      if (radios.length) {
        radios.forEach(function (radio) {
          var isMatch = radio.value === optionValue;
          if (isMatch && !radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event("change", { bubbles: true }));
            changedAny = true;
          }
        });
        return;
      }

      var popoutInput = wrapper.querySelector(
        'input[data-popout-input][data-index="option' + optionPosition + '"]'
      );
      if (popoutInput && popoutInput.value !== optionValue) {
        popoutInput.value = optionValue;
        popoutInput.dispatchEvent(new Event("change", { bubbles: true }));
        changedAny = true;

        var toggleText = wrapper.querySelector("[data-popout-toggle-text]");
        if (toggleText) {
          toggleText.textContent = optionValue;
        }
        var options = wrapper.querySelectorAll("[data-popout-option]");
        options.forEach(function (opt) {
          var isMatch = opt.getAttribute("data-value") === optionValue;
          opt.parentElement.classList.toggle("is-active", isMatch);
          if (isMatch) {
            opt.setAttribute("aria-current", "true");
          } else {
            opt.removeAttribute("aria-current");
          }
        });
      }
    });

    return changedAny;
  }

  function initSync(productImagesEl) {
    var root = getSectionRoot(productImagesEl);
    if (!root) return;

    var product = getProductJSON(root);
    if (!product) return;

    if (productImagesEl.__syncVariantFromImageInit) return;
    productImagesEl.__syncVariantFromImageInit = true;

    var lastHandledMediaId = null;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === "attributes" && m.attributeName === "data-active-media") {
          var mediaId = extractMediaId(
            productImagesEl.getAttribute("data-active-media")
          );
          if (mediaId === null || mediaId === lastHandledMediaId) continue;
          lastHandledMediaId = mediaId;

          var variant = findVariantByMediaId(product, mediaId);
          if (variant) {
            selectVariantInForm(root, variant);
          }
        }
      }
    });

    observer.observe(productImagesEl, {
      attributes: true,
      childList: false,
      subtree: false,
    });
  }

  function initAll() {
    document.querySelectorAll("product-images").forEach(initSync);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target;
    if (root && root.querySelectorAll) {
      root.querySelectorAll("product-images").forEach(initSync);
    }
  });
})();
